import Swiper from 'swiper'

((window, document) => {
    const container = document.querySelector('.js--highlights')

    if (!container)
        return

    const cards = Array.prototype.slice
        .call(container.querySelectorAll('.js--highlight'))

    const overlay = document.querySelector('.js--media-overlay')
    const overlayBody = document.querySelector('.js--media-overlay-body')

    const $ = window.jQuery

    const canHover = Boolean(window.matchMedia)
        && window.matchMedia('(hover: hover) and (pointer: fine)').matches

    let overlayTrigger = null

    /**
    * Get Closest Element
    * @param  {HTML Object} element
    * @param  {String} selector
    * @return {HTML Object|null}
    */
    function closest (element, selector) {
        let node = element

        while (node && node.nodeType === 1) {
            const matches = node.matches
                || node.msMatchesSelector
                || node.webkitMatchesSelector

            if (matches && matches.call(node, selector))
                return node

            node = node.parentElement
        }

        return null
    }

    /**
    * Open a Highlight Card
    * @param  {HTML Object} card
    * @return {Void}
    */
    function openCard (card) {
        const details = card.querySelector('.highlights__details')
        const expand = card.querySelector('.js--highlight-expand')

        if (details)
            details.style.maxHeight = `${details.scrollHeight}px`

        if (expand)
            expand.setAttribute('aria-expanded', 'true')

        card.classList.add('highlights__card_open')
    }

    /**
    * Close a Highlight Card
    * @param  {HTML Object} card
    * @return {Void}
    */
    function closeCard (card) {
        const details = card.querySelector('.highlights__details')
        const expand = card.querySelector('.js--highlight-expand')

        if (details)
            details.style.maxHeight = ''

        if (expand)
            expand.setAttribute('aria-expanded', 'false')

        card.classList.remove('highlights__card_open')
    }

    /**
    * Youtube Video Id
    * @param  {String} url
    * @return {String|null}
    */
    function youtubeId (url) {
        const match = url.match(
            /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]+)/i)

        return match
            ? match[1]
            : null
    }

    /**
    * Vimeo Video Id
    * @param  {String} url
    * @return {String|null}
    */
    function vimeoId (url) {
        const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/i)

        return match
            ? match[1]
            : null
    }

    /**
    * Instagram Embed Url
    * @param  {String} url
    * @return {String|null}
    */
    function instagramEmbed (url) {
        const match = url
            .match(/instagram\.com\/(?:[\w.]+\/)?(p|reel|tv)\/([\w-]+)/i)

        return match
            ? `https://www.instagram.com/${match[1]}/${match[2]}/embed/captioned/`
            : null
    }

    /**
    * Open the Media Overlay
    * @param  {String} embed type - youtube, vimeo or instagram
    * @param  {String} url
    * @param  {HTML Object} trigger element
    * @return {Boolean}
    */
    function openOverlay (type, url, trigger) {
        if (!overlay || !overlayBody || !$)
            return false

        let markup = ''

        if (type === 'youtube') {
            const id = youtubeId(url)

            if (!id)
                return false

            markup = `<iframe src="https://www.youtube.com/embed/${id}?autoplay=1&rel=0"
                title="YouTube video"
                allow="autoplay; encrypted-media; picture-in-picture"
                allowfullscreen></iframe>`
        }

        if (type === 'vimeo') {
            const id = vimeoId(url)

            if (!id)
                return false

            markup = `<iframe src="https://player.vimeo.com/video/${id}?autoplay=1"
                title="Vimeo video"
                allow="autoplay; picture-in-picture"
                allowfullscreen></iframe>`
        }

        if (type === 'instagram') {
            const embed = instagramEmbed(url)

            if (!embed)
                return false

            markup = `<iframe src="${embed}"
                title="Instagram post"
                scrolling="no"></iframe>`
        }

        if (!markup)
            return false

        overlayBody.innerHTML = markup

        const isInstagram = (type === 'instagram')

        overlay.classList.remove(isInstagram
            ? 'media-overlay_video'
            : 'media-overlay_instagram')

        overlay.classList.add(isInstagram
            ? 'media-overlay_instagram'
            : 'media-overlay_video')

        overlayTrigger = trigger || null

        $(overlay).modal('show')

        return true
    }

    // One card open at a time - the arrows and cookie banner overlap the cards,
    // so per-card mouseenter/mouseleave thrash
    const section = closest(container, '.highlights')

    // section top range (viewport fractions) the cards grow over, staggered
    const revealFrom = 0.6
    const revealTo = 0.05

    // phone cards grow from their foot, so start earlier and finish sooner
    const revealFromMobile = 1
    const revealToMobile = 0.45
    const revealStagger = 0.15

    let revealTicking = false

    /**
    * Grow the Cards for the Current Scroll Position
    * @return {Void}
    */
    function paintReveal () {
        revealTicking = false

        const height = window.innerHeight
        const top = section.getBoundingClientRect().top

        const mobile = window.matchMedia
            && window.matchMedia('(max-width: 767px)').matches

        const from = mobile ? revealFromMobile : revealFrom
        const to = mobile ? revealToMobile : revealTo

        const progress = Math.min(Math.max(
            (height * from - top) / (height * (from - to)),
            0), 1)

        const span = 1 - (revealStagger * Math.min(cards.length - 1, 2))

        cards.forEach((card, index) => {
            const own = Math.min(Math.max(
                (progress - (Math.min(index, 2) * revealStagger)) / span,
                0), 1)

            card.style.setProperty(
                '--reveal', (1 - Math.pow(1 - own, 2)).toFixed(3))
        })
    }

    /**
    * Queue a Reveal Paint on the Next Frame
    * @return {Void}
    */
    function requestReveal () {
        if (revealTicking)
            return

        revealTicking = true

        window
            .requestAnimationFrame(paintReveal)
    }

    let active = null
    let dismissed = null

    /**
    * Set the Open Card
    * @param  {HTML Object|null} card
    * @return {Void}
    */
    function setActive (card) {
        if (active === card)
            return

        if (active)
            closeCard(active)

        active = card

        if (card)
            openCard(card)
    }

    cards.forEach((card) => {
        card.addEventListener('click', (event) => {
            if (closest(event.target, 'a'))
                return

            if (!closest(event.target, '.js--highlight-expand') && canHover)
                return

            if (active === card) {
                // Remember the dismissal so hover does not undo it
                dismissed = card
                setActive(null)
            }
            else {
                dismissed = null
                setActive(card)
            }
        })

        card
            .addEventListener('focusin', () => {
                dismissed = null
                setActive(card)

                const index = cards.indexOf(card)
                const view = container.getBoundingClientRect()
                const left = (card.getBoundingClientRect().left
                    + container.scrollLeft)
                const right = (left
                    + card.offsetWidth)

                if (slider
                        && (left < view.left - 1 || right > view.right + 1))
                    slider.slideTo(index)
            })

        card
            .addEventListener('focusout', (event) => {
                if (active === card && !card.contains(event.relatedTarget))
                    setActive(null)
            })
    })

    if (canHover && section) {
        section
            .addEventListener('mouseover', (event) => {
                const card = closest(event.target, '.js--highlight')

                // Arrows sit above the cards; crossing one is not leaving
                if (!card && closest(event.target, '.highlights__arrow'))
                    return

                if (card !== dismissed)
                    dismissed = null

                setActive(card === dismissed
                    ? null
                    : card)
            })

        section
            .addEventListener('mouseleave', (event) => {
                const bounds = section.getBoundingClientRect()

                // Elements floating over the carousel fire mouseleave without an exit
                if (event.clientX > bounds.left
                        && event.clientX < bounds.right
                        && event.clientY > bounds.top
                        && event.clientY < bounds.bottom)
                    return

                dismissed = null
                setActive(null)
            })
    }

    // Focusing a control inside the track scrolls the hidden viewport out of
    // sync with Swiper's transform
    container
        .addEventListener('scroll', () => {
            if (container.scrollLeft)
                container.scrollLeft = 0
        })

    // Re-measure the open card, pinned to the old height
    window
        .addEventListener('resize', () => {
            if (active)
                openCard(active)
        })

    container
        .addEventListener('click', (event) => {
            const link = closest(event.target, '[data-highlight-media]')

            if (!link)
                return

            const type = link.getAttribute('data-highlight-media')
            const url = link.getAttribute('href')

            // An unparseable url falls through to the link
            if (openOverlay(type, url, link))
                event.preventDefault()
        })

    const slider = new Swiper(container, {
        slidesPerView: 1.08,
        spaceBetween: 4,
        threshold: 8,
        watchOverflow: true,
        breakpoints: {
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
        },
        navigation: {
            prevEl: document.querySelector('.js--highlights-prev'),
            nextEl: document.querySelector('.js--highlights-next')
        },
        scrollbar: {
            el: document.querySelector('.js--highlights-progress'),
            draggable: true
        }
    })

    // cards grow up from the bottom as the section scrolls into view
    const canReveal = Boolean(section)
        && Boolean(window.CSS && window.CSS.supports)
        && window.CSS.supports('clip-path', 'inset(0)')
        && window.CSS.supports('width', 'calc((1 - var(--reveal, 0)) * 100%)')
        && !window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (canReveal) {
        section.classList.add('highlights_reveal')

        paintReveal()

        window
            .addEventListener('scroll',
                requestReveal)

        window
            .addEventListener('resize',
                requestReveal)
    }

    // the embed posts its rendered height; its own script never applies it
    window.addEventListener('message', (event) => {
        const frame = overlayBody && overlayBody.querySelector('iframe')

        if (event.origin !== 'https://www.instagram.com'
                || !frame
                || event.source !== frame.contentWindow
                || typeof event.data !== 'string')
            return

        let data

        try {
            data = JSON.parse(event.data)
        }
        catch (error) {
            return
        }

        if (data && data.type === 'MEASURE' && data.details && data.details.height)
            frame.style.height = `${data.details.height}px`
    })

    if (overlay && $)
        $(overlay).on('hidden.bs.modal', () => {
            // Clearing the iframe stops playback
            overlayBody.innerHTML = ''

            overlay.classList.remove('media-overlay_instagram')
            overlay.classList.remove('media-overlay_video')

            if (overlayTrigger) {
                overlayTrigger.focus()
                overlayTrigger = null
            }
        })

    // The pointer lands on a different card once the track moves, unless the
    // keyboard is inside the open one
    slider.on('slideChange', () => {
        if (active && active.contains(document.activeElement))
            return

        dismissed = null
        setActive(null)
    })
})(window, document)
